/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconClockStop = createReactComponent("outline", "clock-stop", "IconClockStop", [["path", { "d": "M21 12a9 9 0 1 0 -9 9", "key": "svg-0" }], ["path", { "d": "M12 7v5l1 1", "key": "svg-1" }], ["path", { "d": "M16 16h6v6h-6z", "key": "svg-2" }]]);

export { IconClockStop as default };
//# sourceMappingURL=IconClockStop.mjs.map
